import { UploadMediaRequest, UploadMediaResponse } from "src/types/media";
import { useMutationBuilder } from "../useBuilders";
import { cleverstoryUploadMediaApi, uploadMediaApi } from "src/services/settings/uploadMedia";
import { MEDIA, UPLOAD } from "../queryKeys";

/**
 * Custom hook to handle uploading media files.
 *
 * Wraps `useMutationBuilder` with predefined mutation keys and API logic.
 *
 * @returns {UseMutationResult<UploadMediaResponse, Error, UploadMediaRequest["media"]>}
 * - `mutate`: function to trigger the media upload
 * - `data`: response of type `UploadMediaResponse` when upload succeeds
 * - `error`: error object if upload fails
 * - `isLoading`: boolean indicating the mutation is in progress
 */

export const useUploadMedia = () => {
  return useMutationBuilder<UploadMediaResponse, UploadMediaRequest["media"]>(
    [UPLOAD],
    (media) => uploadMediaApi(media),
    [MEDIA]
  );
};

export const useCleverstoryUploadMedia = () => {
  return useMutationBuilder<UploadMediaResponse, UploadMediaRequest["media"]>(
    [UPLOAD],
    (media) => cleverstoryUploadMediaApi(media),
    [MEDIA]
  );
};